import React from "react";
import PropTypes from "prop-types";
import has from "lodash/has";
import get from "lodash/get";
import find from "lodash/find";

import {
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
  FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import Resource from "common/components/Resource";
import EnhancedCard from "common/components/EnhancedCard";
import { useTranslation } from "react-i18next";

const clearCustomValues = {
  bogo: {
    buyValue: "",
    getValue: "",
  },
  event: {
    eventType: "",
  },
  "dollar-off": {
    dollarValue: "",
  },
  "percent-off": {
    percentValue: "",
  },
};

const TypeStep = ({ values, errors, setFieldValue }) => {
  const hasId = get(values, "offer_template.id");
  const { t } = useTranslation();
  return (
    <Resource
      name="offer_templates"
      render={(templates) => (
        <Grid container>
          <Grid size={{ xs: 12 }}>
            <EnhancedCard title={t("offer_create.type_label")}>
              <FormControl
                component="fieldset"
                required
                error={has(errors, "offer_template")}
              >
                <RadioGroup
                  name="offerType"
                  value={get(values, "offer_template.id", "")}
                  onChange={(event, value) => {
                    const template = find(templates, { id: value });
                    setFieldValue("offer_template", template);
                    setFieldValue(
                      "custom_values",
                      get(clearCustomValues, value),
                    );
                    setFieldValue("legal", template.legal);
                    setFieldValue("defaultTerms", true);
                  }}
                >
                  {templates.map((template) => (
                    <FormControlLabel
                      key={template.id}
                      value={template.id}
                      control={<Radio />}
                      label={template.name}
                    />
                  ))}
                </RadioGroup>
                {has(errors, "offer_template") && !hasId && (
                  <FormHelperText>
                    {get(errors, "offer_template.id")}
                  </FormHelperText>
                )}
              </FormControl>
            </EnhancedCard>
          </Grid>
        </Grid>
      )}
    />
  );
};

TypeStep.propTypes = {
  values: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
};

export default TypeStep;
